<template>
  <v-container>
    <h2 class="text-center my-12">{{ $t("submitted.title") }}</h2>
    <v-btn @click="$router.push('/')" class="mx-auto d-block" color="green">Back to Home</v-btn>
  </v-container>
</template>

<script>

export default {
  name: 'SubmittedView',
}
</script>
